<template>
  <div :class="divWidthChange" class="conteudoWidth fccUsuarios">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <b-badge
          class="p-2 mr-2 mb-2"
          :variant="filtroBusca == situacao.idfiltro ? 'info' : 'warning'"
          style="cursor: pointer"
          @click=";(filtroBusca = situacao.idfiltro), usuariosListandoExterno()"
          v-for="situacao in buscandoFiltro"
          :key="situacao.tpsituacao"
          >{{ situacao.label }}
        </b-badge>
      </div>
    </div>
    <hr />
    <fccTable
      striped
      hover
      :fields="fields"
      :status="status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePDF"
      :actions="actions"
      addFilter
      :items="usuarioExterno"
    />
    <fccModal centered idModal="addUser" :titleModal="titleModal" escondeFooter travaEsc travaBack>
      <form @submit.prevent="enviarConvite" autocomplete="off">
        <div class="row">
          <div class="col-sm-12 mt-2">
            <fccInput
              extraClasses="inputLabel"
              type="email"
              v-model="usuarios.usupreemail"
              required
            >
              Email
            </fccInput>
          </div>
          <div class="col-sm-12 mt-3">
            <fcc-select
              v-model="usuarios.perid"
              class="mb-4"
              placeholder="Selecione um grupo"
              labelField="perdescricao"
              valueField="perid"
              :clearable="false"
              :options="listaGrupos"
              required
            >
              Grupos
            </fcc-select>
          </div>
          <div class="col-sm-3">
            <fcc-button classeAdd="form-control" tipo="submit">
              <font-awesome-icon icon="paper-plane" size="lg" fixed-width /> Enviar
            </fcc-button>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editUser"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <fccUsuariosCadastroVue
        :usuarioListandoInterno="usuarioListandoInterno"
        :usuarios="usuarios"
        :usuarioComplemento="usuarioComplemento"
        :formActive="formActive"
        :externo="true"
        @limpaIntra="limpaIntra"
        ref="ediLUser"
        @usuariosListandoInterno="usuariosListandoExterno"
      />
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/fccUsuarios.scss'
import fccUsuariosCadastroVue from './fccUsuariosCadastro.vue'

export default {
  data() {
    return {
      usuarioExterno: [],
      filtroBusca: 0,
      buscandoFiltro: [
        {
          idfiltro: 0,
          label: 'Todos os Usuários'
        },
        {
          idfiltro: 1,
          label: 'Bloqueados'
        },
        {
          idfiltro: 2,
          label: 'Não Bloqueados'
        }
      ],
      urlBaseJr: '',
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'usuativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fields: [
        { key: 'usuid', label: 'Login', sortable: true, active: true },
        {
          key: 'usuariocomplemento.usucompdocto',
          label: 'CPF',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompdocto' }
        },
        {
          key: 'usuariocomplemento.usucompnome',
          label: 'Nome',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompnome' }
        },
        {
          key: 'usuariocomplemento.usucompdsemail',
          label: 'E-mail',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompdsemail' }
        },
        {
          key: 'usubloqueioadm',
          label: 'Bloqueio',
          active: true,
          type: 'toggle',
          funcaoButton: 'desbloqueio',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'usulastlogin', label: 'Último login', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editUser',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'resetarSenha',
          icon: 'key',
          tooltip: 'Resetar Senha',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'boasVindas',
          icon: 'envelope',
          tooltip: 'Boas Vindas',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'deleteUser',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      sortBy: 'ordem',
      titlePage: 'Usuários Externos',
      titleModal: '',
      titlePDF: 'Usuários',
      usuarios: {
        usupreemail: '',
        usupreurl: document.location.origin + document.location.pathname + '#/cadastro-externo'
      },
      usuarioListandoInterno: [],
      formActive: false,
      listaUrl: store.state.albumfamilia,
      usuarioComplemento: {},
      itemPorPage: '100',
      listaGrupos: []
    }
  },
  methods: {
    listandoGrupos() {
      axios
        .get(this.baseUrlSecurity + 'Perfil/listarperfil', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listaGrupos = response.data
          if (this.listaGrupos && this.listaGrupos.length > 0) {
            this.listaGrupos = this.listaGrupos.filter((el) => el.perexterno)
          }
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    addField() {
      this.titleModal = 'Enviar convite'
      this.$root.$emit('bv::show::modal', 'addUser')
    },
    desbloqueio(_, item) {
      const mensagem = item.usubloqueioadm
        ? 'Usuário bloqueado com sucesso?'
        : 'Usuário desbloqueado com sucesso?'
      this.bloqueioUserGenerico(item)
        .then((response) => {
          this.usuariosListandoExterno()

          this.callAlert('Sucesso', mensagem, response.data)
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    listarPermissaoPorUsuario(id) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Menu/listarmenuusuario?usuID=' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.permissaoUsuario = response.data
          this.listaGruposDoUsuario(this.allUsers)
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    deleteUser(_, item) {
      this.callConfirm(this.mensagemExcluir, item.usuid).then((result) => {
        if (result.value) {
          this.deleteUserGenerico(item)
            .then(() => {
              if (item.usuemuid > 0) {
                this.deleteEmulador(item.usuemuid)
              }
              this.usuariosListandoExterno()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    resetarSenha(_, item) {
      this.callConfirm('Resetar a Senha?', item.usuid).then((result) => {
        if (result.value) {
          this.resetarSenhaGenerico(item)
            .then((response) => {
              this.callAlert('Sucesso', response.data)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    boasVindas(_, item) {
      this.callConfirm('Reenviar e-mail?', item.usuid).then((result) => {
        if (result.value) {
          this.boasVindasGenerico(item)
            .then((response) => {
              this.callAlert('Sucesso', response.data)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    limpaIntra() {
      this.usuarios = {}
      this.usuarioComplemento = {}
    },
    changeStatus(_, item) {
      this.usuarios = item
      this.usuarioComplemento = item.usuariocomplemento
      this.editandoUserGenerico(item, item.usuariocomplemento)
    },
    editUser(_, item) {
      this.limpaIntra()
      this.titleModal = 'Editar Usuário'
      this.usuarios = item
      this.emularPermite = item.usupermiteemular
      this.usuarioComplemento = item.usuariocomplemento
      this.formActive = true
      this.$root.$emit('bv::show::modal', 'editUser')
    },

    listaPermissaoUsuario(_, item) {
      this.allUsers = item.usuariocomplemento.usuid
      this.nomeAdmin = item.usuariocomplemento.usucompnome
      this.listarPermissaoPorUsuario(item.usuid)
      this.printItem = item.usuid
      this.$root.$emit('bv::show::modal', 'listaPermissaoUsuario')
    },
    enviarConvite() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlSecurity + 'Cadastro/incluirprecadastro',
          this.usuarios,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.usuariosListandoExterno()
          this.$root.$emit('bv::hide::modal', 'addUser')
          this.callToast('E-mail enviado com sucesso', 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    usuariosListandoExterno() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSecurity + 'Cadastro/listartodosloginexterno',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          switch (this.filtroBusca) {
            case 1:
              this.usuarioExterno = response.data.filter((e) => e.usubloqueioadm == true)
              break
            case 2:
              this.usuarioExterno = response.data.filter((e) => e.usubloqueioadm != true)
              break
            default:
              this.usuarioExterno = response.data
              break
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  created() {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranc
    this.usuariosListandoExterno()
    this.listandoGrupos()
    this.urlBaseJr =
      document.location.origin == 'https://sgp.fcc.org.br' ||
      document.location.origin == 'http://sgp.fcc.org.br'
        ? 'https://extranet.fcc.org.br'
        : document.location.origin
    this.usuarios.usupreurl = this.urlBaseJr + document.location.pathname + '#/cadastro-externo'
  },
  components: { fccUsuariosCadastroVue }
}
</script>
